import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Segment,
  Grid,
  Dropdown,
  Loader
} from 'semantic-ui-react'

import find from 'lodash/find'

import './Facsimile.css'
import SectionStudents from './SectionStudents'

const _ = { find }

const FacsimilePV = (props) => {
  if (props.auth) {
    if (props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar' || props.userType === 'adviser' || props.userType === 'levelHead') {
    const {
      sections, sectionId, sectionStudents, currentSchoolYear, schoolYears, schoolYearId
    } = props;

    if (!currentSchoolYear && sections) return <Loader active inline='centered' />;
    let optionsSchoolYears;
    if (schoolYears) {
      optionsSchoolYears = schoolYears.map((schoolYear,index) => {
        return (
            { key: schoolYear.schoolYearId, value: schoolYear.schoolYearId, text: schoolYear.name }
        )
      })
    }

    let optionsSections;
    if (sections) {
      optionsSections = sections.map((section,index) => {
        const displayText = section.gradeLevel + ' - ' + section.name;
        return (
            { key: section.sectionId, value: section.sectionId, text: displayText }
        )
      })
    }

    return (
      <div>
        <Segment>
          <Grid centered columns={5}>
            <Grid.Column>
              <Dropdown
                selection
                name='schoolYearId'
                options={optionsSchoolYears}
                onChange={props.handleChange}
                value={schoolYearId}
              />
            </Grid.Column>
            <Grid.Column>
              <Dropdown
                selection
                search
                clearable
                name='sectionId'
                placeholder='Section'
                options={optionsSections}
                onChange={props.handleChange}
                value={sectionId}
              />
            </Grid.Column>
          </Grid>
          {
            props.loadingStudents ?
            <Loader active inline='centered' /> :
            sectionStudents.length !== 0 ?
            <SectionStudents
              sectionStudents={sectionStudents}
              handleRowClick={props.handleRowClick}
              schoolYear={_.find(schoolYears || [], { schoolYearId: schoolYearId })}
              section={_.find(sections || [], { sectionId: sectionId })}
              currentQuarter={props.currentQuarter}
            /> :
            <Segment textAlign='center'>No students found for this section.</Segment>
          }

        </Segment>
      </div>
    )
  } else {
    return <Segment>You are not authorized to be in this page.</Segment>
  }
  } else {
    return <Redirect to='/' />
  }

}

export default FacsimilePV;
